import React, { PureComponent } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Breadcrumb, Row, Col, Input, Pagination, Card, Table, Badge, Select, Button, Modal, Tooltip } from 'antd';
import { Cascader, OrderForm } from '../../../components';
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import { Order, Dashboard } from "../../../models";
import statusEnum from '../statusEnum.json';
import styles from './index.less';

const paymentEnum = {
  cash: 'Бэлэн',
  noncash: 'Бэлэн бус',
};

const mapStateToProps = state => ({
  orderList: state.order.all,
  statList: state.dashboard.stat,
  districts: state.global.districts,
});

class UBshopOrderList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      offset: 0,
      address: '',
      tel: '',
      district_id: undefined,
      filtered: false,
      status: undefined,
      visible: false,
      currentOrder: null,
      seconds: 30,
    };
  }
  state = { visible: false }

  componentDidMount() {
    this.refresh();
    this.interval = setInterval(this.countdown, 1000);
  }

  componentWillUnmount = () => {
    clearInterval(this.interval);
  }

  countdown = () => {
    if (this.state.seconds > 1) {
      this.setState({
        seconds: this.state.seconds - 1,
      });
    } else {
      this.reCount();
    }
  }

  reCount = () => {
    this.setState({
      seconds: 30,
    }, () => {
      this.refresh();
    });
  }

  handleSelectChange = (record, value) => {
    this.props.update({
      body: {
        ...record,
        state: value,
      },
    });
  };

  showModal = (order) => {
    this.setState({
      visible: true,
      currentOrder: order,
    }, () => {
      console.log(this.state);
    });
  }

  handleCancel = () => {
    this.setState({
      visible: false,
      currentOrder: null,
    });
  }

  handleSelectChange = (value, id) => {
    this.props.update({
      body: {
        id,
        state: value,
      },
    });
  };

  handleNoteChange = (value, id) => {
    this.props.update({
      body: {
        id,
        note: value,
      },
    });
  };

  handleSubmit = async (data) => {
    this.setState({
      visible: false,
      currentOrder: null,
    });
    await this.props.update({ body: data.formData });
    this.refresh();
  }

  handleTableChange = (page, pageSize, string, key) => {
    this.setState({
      ...this.state,
      offset: page - 1,
      limit: pageSize,
      [key]: string,
    }, () => this.refresh());
  }

  refresh = () => {
    this.props.orders({ body: this.state });
    this.props.stats({ body: this.state });
  }

  columns = [{
    title: 'ID',
    key: 'id',
    dataIndex: 'id',
    render: id => <Link to={`orders/detail/${id}`} className={styles.orderId}>{id}</Link>,
    width: '100px',
  }, {
    title: 'Утасны дугаар',
    key: 'tel',
    dataIndex: 'tel',
    width: '220px',
  }, {
    title: 'Хаяг',
    key: 'address',
    dataIndex: 'address',
    width: '250px',
    render: text => (
      <Tooltip
        placement="top"
        title={text}
        autoAdjustOverflow
      >
        <div style={{
          maxWidth: 250,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  }, {
    title: 'Статус',
    key: 'state',
    dataIndex: 'state',
    width: '180px',
    render: (text, record) => (
      <div className={styles.editableCell}>
        <a onClick={() => this.showModal(record)} className={styles.orderStatus}>
          <Badge status={statusEnum[record.state].status} text={statusEnum[record.state].text} className={styles.orderBadge} />
          {/*
          <Icon
            type="edit"
            className={styles.editableCellIcon}
            onClick={() => this.showModal(record)}
          />
          */}
        </a>
      </div>
    ),
  }, {
    title: 'Нийт дүн',
    key: 'sum',
    align: 'right',
    width: '130px',
    render: (text, record) => (
      <div>
        {
          (record && record.carts ? record.carts.reduce((accumilator, element) => {
            let { price } = element.product;
            if (element.product.discount_price) {
              price = element.product.discount_price;
            }
            return accumilator + (price * element.quantity);
          }, 0) : 0).toLocaleString()
        } ₮
      </div>
    ),
  }, {
    title: 'Дүүрэг',
    key: 'district.district.name',
    dataIndex: 'district.district.name',
    width: '150px',
  }, {
    title: 'Төлбөрийн нөхцөл',
    key: 'payment',
    width: '160px',
    render: (name, record) => <span>{paymentEnum[record.payment]}</span>,
  }, {
    title: 'Үүсгэсэн',
    key: 'created_at',
    dataIndex: 'created_at',
    width: '190px',
    render: (name, record) => <div style={{ wordBreak: 'keep-all' }}>{moment(`${record.created_at}`).format('YYYY.MM.DD HH:mm')}</div>,
  }];

  filterHidden() {
    this.setState({
      isHidden: !this.state.isHidden,
    });
  }

  render() {
    const { orderList } = this.props;
    // const dataSource = [{
    //   key: '1',
    //   productName: 'monster black assault энергийн ундаа 500мл',
    //   quantity: 4,
    //   total: 3000,
    // }, {
    //   key: '1',
    //   productName: 'monster black assault энергийн ундаа 4500мл',
    //   quantity: 4,
    //   total: 3000,
    // }];

    const columns = [{
      title: 'Бараа',
      dataIndex: 'product.title',
      key: 'productName',
    }, {
      title: 'Ширхэг',
      dataIndex: 'quantity',
      key: 'quantity',
    }, {
      title: 'Нийт',
      // dataIndex: 'total',
      key: 'total',
      align: 'right',
      render: (text, record) => <div>{`${record.product.discount_price ? (record.product.discount_price * record.quantity).toLocaleString() : (record.product.price * record.quantity).toLocaleString()} ₮`}</div>,
    }];
    const form = {
      schema: {
        title: 'Form',
        type: 'object',
        required: [],
        properties: {
          state: {
            type: 'string',
            label: 'Статус',
            column: 12,
            key: "state",
            options: Object.keys(statusEnum).map(el => ({
              _id: el,
              name: statusEnum[el].text,
            })),
          },
          note: {
            type: 'string',
            column: 12,
            label: 'Тэмдэглэл',
          },
        },
      },
      uiSchema: {
        state: {
          "ui:widget": 'select',
          "ui:placeholder": "Статус оруулна уу",
        },
        note: {
          "ui:widget": 'textarea',
          "ui:placeholder": "Тэмдэглэл оруулна уу",
        },
      },
    };

    const breadcrumb = (
      <Col span={24}>
        <div className={styles.pageTop}>
          <Col span={5}>
            <Breadcrumb className={styles.Topbread}>
              <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
              <Breadcrumb.Item>Захиалга</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col span={19} style={{ marginTop: 3 }}>
            <div className={styles.TopGuide}>
              <ul className={styles.orderGuide}>
                <li> Нийт Захиалга: <strong>{this.props.orderList.total}</strong></li>
              </ul>
              <Link to="/log" className={styles.topBtn}>
                <Button icon="inbox" type="primary" size="small" style={{ fontSize: 13 }}>Захиалгын лог</Button>
              </Link>
            </div>
          </Col>
        </div>
      </Col>);

    let sum = this.state.currentOrder && this.state.currentOrder.carts ? this.state.currentOrder.carts.reduce((accumilator, element) => {
      let { price } = element.product;
      if (element.product.discount_price) {
        price = element.product.discount_price;
      }
      return accumilator + (price * element.quantity);
    }, 0) : 0;

    return (
      <PageHeaderLayout
        content={breadcrumb}
      >
        <Card bordered>
          <Row type="flex" justify="start" gutter={20}>
            <Col span={24}>
              <Col span={12}>
                <span className={styles.pageHeading}>Захиалга</span>
              </Col>
              <Col span={12} style={{ textAlign: 'right' }}>
                <Button size="small" loading={orderList.isLoading} onClick={this.reCount}>{`Шинэчлэх ${this.state.seconds} секунд`}</Button>
              </Col>
            </Col>
            <Col span={24}>
              <div style={{ marginTop: 20 }}>
                <div style={{ width: '100%', float: 'left', marginBottom: 20 }}>
                  <Col span={6}>
                    <div style={{ paddingRight: 10 }}>
                      <Input.Search
                        placeholder="Хаягаар хайх"
                        size="small"
                        value={this.state.address}
                        onChange={event => this.handleTableChange(1, this.state.limit, event.target.value, 'address')}
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ paddingRight: 10 }}>
                      <Select
                        showSearch
                        size="small"
                        style={{ width: '100%' }}
                        placeholder="Статусаар хайх"
                        value={this.state.status}
                        onChange={value => this.handleTableChange(1, this.state.limit, value, 'status')}
                      >
                        <Select.Option value="">--Бүгд--</Select.Option>
                        {Object.keys(statusEnum).map(entry => (
                          <Select.Option key={entry} value={entry}>{statusEnum[entry].text}</Select.Option>
                        ))
                        }
                      </Select>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ paddingRight: 10 }}>
                      <Cascader
                        array={this.props.districts}
                        valueKey="id"
                        labelKey="name"
                        childrenKey="districts"
                        size="small"
                        placeholder="Дүүргээр хайх"
                        style={{ width: '100%' }}
                        onChange={value => this.handleTableChange(1, this.state.limit, value, 'district_id')}
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div>
                      <Input.Search
                        placeholder="Утасны дугаараар хайх"
                        size="small"
                        value={this.state.tel}
                        onChange={event => this.handleTableChange(1, this.state.limit, event.target.value, 'tel')}
                      />
                    </div>
                  </Col>
                </div>
              </div>
            </Col>
            <Col span={5} />
          </Row>
          <Row type="flex" justify="end" gutter={20}>
            {/* <Col span={4}>
              <Select
                showSearch
                size="default"
                style={{ width: '100%' }}
                placeholder="Дүүргээр хайх"
                optionFilterProp="children"
                value={this.state.district_id}
                onChange={value => this.handleTableChange(1, this.state.limit, value, 'district_id')}
              >
                {this.props.districts.map(district => (
                  <Select.Option key={district.id} value={district.id}>{district.name}</Select.Option>
                ))}
              </Select>
            </Col> */}
          </Row>
          <Table
            className={styles.dataTable}
            rowKey={record => record.id}
            columns={this.columns}
            dataSource={[...orderList.data]}
            pagination={false}
            loading={orderList.isLoading}
            scroll={{ x: 1470 }}
          />
          <div style={{ marginTop: 20, float: 'right' }}>
            <Pagination
              defaultCurrent={1}
              onChange={this.handleTableChange}
              pageSize={this.state.limit}
              total={this.props.orderList.total}
              current={this.state.offset + 1}
              size="small"
            />
          </div>
        </Card>
        <Modal
          title="Захиалгын статус өөрчлөх"
          visible={this.state.visible}
          width={620}
          onCancel={this.handleCancel}
          footer={false}
        >
          <div className={styles.orderLocation}>
            Хүргэлтийн хаяг: <b>{this.state.currentOrder ? `${this.state.currentOrder.district.district && this.state.currentOrder.district.district.name} ${this.state.currentOrder.district.name} ${this.state.currentOrder.address}` : ''}</b>
          </div>
          {this.state.visible &&
            <OrderForm
              form={form}
              data={({
                id: this.state.currentOrder.id,
                state: this.state.currentOrder ? this.state.currentOrder.state : '',
              })}
              onSubmit={this.handleSubmit}
            />
          }
          <Table dataSource={this.state.currentOrder ? this.state.currentOrder.carts : []} columns={columns} pagination={false} className={styles.dataTable} />
          <Row>
            <Col span={24} style={{ marginTop: 20 }}>
              <span style={{ float: 'right', color: 'rgba(0, 0, 0, 0.85)', fontSize: 16 }}> Нийт: {sum.toLocaleString()} ₮</span>
            </Col>
          </Row>
        </Modal>
      </PageHeaderLayout>
    );
  }
}

UBshopOrderList.propTypes = {
  districts: PropTypes.array.isRequired,
  orders: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  orderList: PropTypes.object,
  stats: PropTypes.func.isRequired,
};

UBshopOrderList.defaultProps = {
  orderList: [],
};

export default connect(mapStateToProps, {
  orders: Order.all,
  update: Order.update,
  stats: Dashboard.stat,
})(UBshopOrderList);



// WEBPACK FOOTER //
// ./src/containers/Orders/List/index.js